import { useEffect, useState } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { getFocus, useGet } from "state/jotai";
import { useBreak } from "hooks/useBreak";
import { _bootstrap } from "state/store.bootstrap";
import moment from "moment";
import { _isometry } from "state/store.isometry";
import { KeepScale } from "react-zoom-pan-pinch";


export const Label = ({
  c,
  sc,
  d,
  l,
  rmode,
  r,
  labelsInfo,
  line,
  angle,
  mobileLabelAxis,
  showLabel,
  setShowLabel,
  hoveredId,
}) => {
  const isMobile = useBreak("md_dn");

  const { pin, pid } = useGet(active_project);
  const unitStatus = getFocus(_project, "unitStatuses")?.[pin]?.[pid] ?? [];
  const availableTranslation =
    unitStatus?.filter((u) => u.ID === 10)?.[0]?.Name ?? "";

  const projectUnitsStatus = getFocus(_bootstrap, "projects");
  const options = getFocus(_project, "filteroptions");
  const PID = labelsInfo?.PID;

  const PIN = labelsInfo?.PIN;
  const unitsCounts = projectUnitsStatus?.filter((p) => p?.ProjectID === PID);
  const allUnits = getFocus(_project, "units");

  // const totalUnits = unitsCounts?.[0]?.NoOfSalesUnits;
  const totalUnits = allUnits?.[pin]?.[pid]?.Units?.reduce(
    (ac, val) => (ac += val?.Data?.ProjectID?.Value === PID ? 1 : 0),
    0,
  );
// console.log(totalUnits,"kkk")

  const roomSize = options[PIN]?.[PID]?.filter(
    (p) => p?.Label === "Størrelse",
  )?.[0];
  const here = useLocation().pathname.split("/");

  // Property sales type checking
  const salesName = "Salg";
  const rentalName = "Leje";

  const porpertyType = {
    sales: false,
    rental: false,
  };

  let typesDone = false;

  // Number of rooms
  let noRmin = Infinity;
  let noRmax = 0;

  // Number of room size
  let rMinSize = Infinity;
  let rMaxSize = 0;

  // Move in date
  let today = moment().startOf("day");
  let mDate = null;
  let foundToday = false;

  if (Object.keys(allUnits[PIN]?.[PID] || {}).length) {
    for (let i = 0; i < allUnits[PIN]?.[PID]?.Units.length; i++) {
      const val = allUnits[PIN]?.[PID]?.Units[i].Data;
      const sID = val.UnitStatusID.Value;

      // Number of rooms
      const noRooms = val.VaerelserAntal.Value;
      noRmin = Math.min(noRmin, noRooms);
      noRmax = Math.max(noRmax, noRooms);

      // Number of room size
      const rSize = val.Areal.Value;
      if (rSize !== 0) {
        rMinSize = Math.min(rMinSize, rSize);
        rMaxSize = Math.max(rMaxSize, rSize);
      }

      // Move in date
      const cuDate = val.Indflytningsdato?.Value;

      if (cuDate && sID === 10) {
        const moveIn = moment(cuDate, "DD-MM-YYYY", true);

        if (moveIn.isValid()) {
          // Highest priority: same day as today
          if (moveIn.isSame(today, "day")) {
            mDate = moveIn;
            foundToday = true;
          }

          // Second priority: nearest future date
          else if (!foundToday && moveIn.isAfter(today, "day")) {
            if (!mDate || moveIn.isBefore(mDate, "day")) {
              mDate = moveIn;
            }
          }
        }
      }

      if (porpertyType.rental && porpertyType.sales) {
        typesDone = true; // stop checking types, NOT the loop
      }

      if (!typesDone) {
        if (val.SalesTypeLejelejlighed.Value) {
          porpertyType.rental = true;
        } else if (val.SalesTypeEjerlejlighed.Value) {
          porpertyType.sales = true;
        }
      }
    }
  }

  // Rule 3: if mDate is still null → send null to frontend
  const finalMdate = mDate ? mDate.format("DD-MM-YYYY") : null;

  const saletype =
    porpertyType.sales && porpertyType.rental
      ? `${rentalName} & ${salesName}`
      : porpertyType.sales
      ? salesName
      : porpertyType.rental ? rentalName : '';
      
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const isOverview = here[here.length - 1] === "isometry";

  const [notHovered, setNotHovered] = useState(true);

  const click = useClick();

  // 🔑 SAFARI-SAFE SCALE (math only)
  const s = sc && sc !== Infinity ? 0.6 / sc : 1;
  const cx = r?.[0];
  const cy = r?.[1];

  const dl = { d, l, s, notHovered };
  const projectExtraInfo = {
    Neptunus: {
      name: "NEPTUNUS",
      moveIn: "Indflytning 2027",
    },
    Dannebroge: {
      name: "DANNEBROGE",
      moveIn: "Indflytning 2026",
    },
    Gyldenløve: {
      name: "Gyldenløve",
      moveIn: "Indflytning Marts 2026",
    },
    Skibet: {
        name: "Skibet",
    },
    Broen: {
        name: "Broen",
    },
   "Hvide Falk": {
      name: "Hvide Falk",
      moveIn: "Klar til indflytning",
    },
    Postillionen: {
      name: "Postillionen",
      moveIn: "Udsolgt",
    }
    // Add more projects here
  };

  const currentProjectInfo = projectExtraInfo[labelsInfo?.Presentation];
  useEffect(() => {
    if (hoveredId === labelsInfo?.URLSafe) {
      setNotHovered(false);
    } else {
      setNotHovered(true);
    }
  }, [hoveredId]);

  if (isOverview && !rmode) {
    return (
      <Pos c={c} style={{
          zIndex: hoveredId === labelsInfo?.URLSafe ? 10 : 5
      }}>
        <div style={{ transform: `scale(${1*s + 0.3})` }}>
          <Svg viewBox="0 0 100 100">
            <CircleGroup transform={`translate(50 50)`}>
              <Circle cx={0} cy={0} r={15} clr={clr} />
              <Circle cx={0} cy={0} r={25} fillOpacity="0.5" clr={clr} />
              <Circle cx={0} cy={0} r={35} fillOpacity="0.3" clr={clr} />
            </CircleGroup> 
          </Svg>
        
        {hoveredId == labelsInfo?.URLSafe? (
          <Outer {...dl} xAxis={"-110"} yAxis={""}>
            <LabContainer {...dl} clr={clr} onClick={!isMobile ? () => click(labelsInfo) : null}>
              <Text2 style={{ borderBottom: "2px solid #fff", padding: "8px 16px" }}>
              {labelsInfo?.URLSafe === "postillionen"
                 ? "Udsolgt"
                 : `Boliger til ${saletype}`}
              </Text2>
             <Lab clr={clr}>
  <Text1 s={s}>{labelsInfo?.Presentation}</Text1>

  {/* Replace ONLY the 88 boliger / 61 ledige rows for Dannebroge */}
  {labelsInfo?.URLSafe === "dannebroge" ? (
    <>
      <Text2 className="paragraph2-regular">
        Indflytning
      </Text2>

      <Text2 className="paragraph2-regular">
      December 2026
      </Text2>
    </>
  ) :
  labelsInfo?.URLSafe === "neptunus" ? (
    <>
      <Text2 className="paragraph2-regular">
        Indflytning
      </Text2>

      <Text2 className="paragraph2-regular">
       April 2027
      </Text2>
    </>
  ) 
  : (
    <>
      <Text2 className="paragraph2-regular">
        {totalUnits}&nbsp;
        {totalUnits > 1
          ? buttonsLabel
              ?.filter((btn) => btn.UILabelProperty === "boliger")[0]
              ?.Label?.toLowerCase()
          : buttonsLabel
              ?.filter((btn) => btn.UILabelProperty === "bolig")[0]
              ?.Label?.toLowerCase()}
      </Text2>

      <Text2 className="paragraph2-regular">
  {labelsInfo?.available_Units}{" "}
  {labelsInfo?.available_Units > 1
    ? buttonsLabel
        ?.filter((btn) => btn.UILabelProperty === "Ledige")[0]
        ?.Label?.toLowerCase()
    : availableTranslation?.toLowerCase()}
</Text2>
    </>
  )}

  {/* KEEP AREA */}
  {rMaxSize && (
    <Text2 className="paragraph2-regular">
      {`${rMinSize} - ${rMaxSize} ${roomSize?.Postfix}`}
    </Text2>
  )}

  {/* KEEP ROOMS */}
  {noRmax && (
    <Text2 className="paragraph2-regular">
      {`${noRmin} - ${noRmax}`}{" "}
      {noRmax > 1
        ? buttonsLabel?.filter(
            (btn) => btn.UILabelProperty === "værelser",
          )[0]?.Label
        : buttonsLabel?.filter(
            (btn) => btn.UILabelProperty === "værelse",
          )[0]?.Label}
    </Text2>
  )}

  {/* KEEP MOVE-IN DATE */}
  {finalMdate && labelsInfo?.URLSafe !== "neptunus" && (
    <Text2 className="paragraph2-regular">
      {buttonsLabel?.filter(
        (btn) => btn.UILabelProperty === "Indflytning",
      )[0]?.Label}{""}
      : {finalMdate}
    </Text2>
  )}
</Lab>
            </LabContainer>
          </Outer>
        ) : (
          <Outer
            {...dl}
            xAxis={isMobile ? mobileLabelAxis?.[0] : ""}
            yAxis={isMobile ? mobileLabelAxis?.[1] : ""}
          >
              <LabContainer
                {...dl}
                clr={clr}
                onClick={!isMobile ? () => click(labelsInfo) : null}
              >
                 {/* Extra project name */}
                {currentProjectInfo?.name && (
                  <Text1
                    className="paragraph2-regular"
                    style={{ padding: "8px 16px 4px 16px" }}
                  >
                    {currentProjectInfo.name}
                  </Text1>
                )}


                {/* Extra move-in date */}
                {currentProjectInfo?.moveIn && (
                  <Text2
                    className="paragraph2-regular"
                    style={{ padding:  labelsInfo?.URLSafe === 'neptunus' || labelsInfo?.URLSafe === 'postillionen' || labelsInfo?.URLSafe === 'hvidefalk'? "4px 16px 8px 16px" : "4px 16px" }}
                  >
                    {currentProjectInfo.moveIn}
                  </Text2>
                )}
                {
                  labelsInfo?.URLSafe !== 'neptunus' && labelsInfo?.URLSafe !== "postillionen" && labelsInfo?.URLSafe !== "hvidefalk" && ( <Text2
                  className="paragraph2-regular"
                  style={{ padding: "4px 16px 8px 16px" }}
                >
                  Boliger til {saletype}
                </Text2>
                  )
                }
              </LabContainer>
        
          </Outer>
        )}
        </div>
        {/* <KeepScale> */}
           
        {/* </KeepScale> */}
      </Pos>
    );
  }

  return null; // Return null or another component if conditions are not met
};
